import gql from 'graphql-tag';

import HEUserDetails from '../../queries/heUserDetails';

export default gql`
  mutation updateHEUser($input: updateHEAccountInput!) {
    updateHEAccount(input: $input) {
      heAccount {
        id
        primaryUser {
          ...HEUserDetails
        }
        userList {
          ...HEUserDetails
        }
      }
    }
  }
  ${HEUserDetails}
`;
